import { TuiAvatar } from '@taiga-ui/kit';
import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { TuiDataList, TuiDropdown, TuiInitialsPipe } from '@taiga-ui/core';
import { Store } from '@ngxs/store';
import { toSignal } from '@angular/core/rxjs-interop';
import { take } from 'rxjs';
import { Router } from '@angular/router';
import { AuthState } from '@store/auth/auth.state';
import { Logout } from '@store/auth/auth.actions';
import { RouteNames } from '../../../../route-names';

@Component({
  selector: 'app-user-menu',
  imports: [TuiDropdown, TuiAvatar, TuiDataList, TuiInitialsPipe],
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserMenuComponent {
  userState = toSignal(this.store.select(AuthState.getUserPersonalData));

  userFullName = computed(
    () => `${this.userState()?.firstName} ${this.userState()?.lastName}`,
  );

  constructor(
    private readonly store: Store,
    private readonly router: Router,
  ) {}

  protected logout() {
    this.store
      .dispatch(new Logout())
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.router.navigate([RouteNames.MAIN_PAGE]);
        },
      });
  }
}
